export const ZENDESK_URL = 'https://support.muscle-booster.io/';
export const ZENDESK_ANDROID_URL = '351042-android';
export const ZENDESK_IOS_URL = '377154-ios';
export const CONTACT_US_LINK = 'https://contact-us.welltech.com/musclebooster.html';
